import { Box, Typography } from "@mui/material";
import { CalendarToday, LocationOn } from "@mui/icons-material";

interface LocationDateInfoProps {
  location?: string;
  date?: string;
}

export default function LocationDateInfo({ location, date }: LocationDateInfoProps) {
  if (!location && !date) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "row", sm: "row" },
        gap: { xs: 1.5, sm: 1.5 },
        alignItems: "center",
      }}
    >
      {location && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <LocationOn fontSize="small" color="action" sx={{ fontSize: "0.875rem" }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: { xs: "0.75rem", sm: "0.75rem" } }}
          >
            {location}
          </Typography>
        </Box>
      )}
      {date && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <CalendarToday fontSize="small" color="action" sx={{ fontSize: "0.875rem" }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: { xs: "0.75rem", sm: "0.75rem" } }}
          >
            {date}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

